//Set enumeration for themes
export enum Theme{
    VIRTUALLAUNDRY = 'virtuallaundry',
    NEWASCO = 'newasco',
    WASMIJNWAS = 'wasmijnwas',
  }
  
  //Set configuration for each app
  const themeConfig = {
    [Theme.VIRTUALLAUNDRY]: {
      appId: 'com.it2.virtuallaundry',
      appName: 'VL App'
    },
    [Theme.NEWASCO]: {
      appId: 'com.it2.newasco',
      appName: 'Newasco App',
      appLanguage: 'nl-NL',
      webportalUrl: 'https://newasco.virtuallaundry.net/service.asmx'
    },
    [Theme.WASMIJNWAS]: {
      appId: 'com.it2.wasmijnwas',
      appName: 'Wasmijnwas',
      appLanguage: 'nl-NL',
      webportalUrl: 'https://wasmijnwas.virtuallaundry.net/service.asmx'
    }
  };
  
  //Change this to set the app that should be build
  export const currentTheme: Theme = Theme.VIRTUALLAUNDRY;

  //Set themeConfig according to currentTheme
  export const { appId, appName, webportalUrl, appLanguage } = themeConfig[currentTheme] as any;
